module.exports = __webpack_public_path__ + "static/media/valery.1b247fe8.png";